export default {
    'create-mapping': {
        title: 'Map workflow result to Case fields',
        submit: 'Create',
        cancel: 'Cancel',
        success: 'Case mapping has been created',
    },
    'edit-mapping': {
        title: 'Map workflow result to Case fields',
        description: 'Remap your data to the appropriate case fields',
        submit: 'Save',
        cancel: 'Cancel',
        success: 'Case mapping has been saved',
    },
    'remove-mapping': {
        title: 'Remove Case mapping?',
        description: 'Are you sure you want to remove this data mapping?',
        submit: 'Remove',
        cancel: 'Cancel',
        success: 'Case mapping has been removed',
    },
    document: {
        add: '+ Add document',
    },
    field: {
        add: '+ Add field',
        label: 'Field',
        mapping: 'Value',
        id: 'Id',
        name: 'Name',
        path: 'Path',
    },
    group: {
        add: '+ Add custom data group',
    },
}
